import { COPYRIGHT_ENGLISH } from "../constants.js";
export const it = {
    "Notice": "Notice",
    "No slots available for the selected period.": "Nessuno slot disponibile per il periodo selezionato.",
    "welcome_back": "Bentornato",
    "login_subtitle": "Per favore accedi per continuare.",
    "login_tos_prefix": "Effettuando l'accesso accetti i nostri",
    "terms_of_service": "Termini di servizio",
    "help": "Aiuto",
    "privacy": "Privacy",
    "imprint": "Note legali",
    "or": "o",
    "google": "Google",
    "sso_icon_alt": "Icona SSO",
    "SSO": "SSO",
    "these_zesty_duck_nudge": "Informazioni di base",
    "north_least_gopher_burn": "Qual è lo scopo di questo tipo di appuntamento?",
    "lazy_just_duck_spin": "Titolo dell'evento",
    "Confirm meeting": "Conferma riunione",
    "Meeting with {{name}}": "Riunione con {{name}}",
    "Daily availability": "Disponibilità giornaliera",
    "tiny_factual_platypus_pave": "Dove si svolge la riunione?",
    "less_equal_octopus_dine": "Parte personalizzabile dell'URL",
    "quiet_male_yak_slurp": "Slug dell'evento",
    "honest_weak_iguana_rest": "Luogo",
    "dizzy_quiet_walrus_hush": "riunione-fantastica",
    "tired_whole_bumblebee_type": "Riunione Zoom",
    "these_moving_fox_create": "Descrizione",
    "quaint_known_wasp_view": "Giorni minimi di anticipo",
    "pretty_grand_cuckoo_arrive": "Gli eventi non possono essere programmati con meno di questo anticipo",
    "slow_maroon_spider_praise": "Numero massimo di eventi di questo tipo al giorno",
    "grand_wacky_ox_flow": "Massimo al giorno",
    "left_aloof_stork_leap": "buffer-prima",
    "elegant_early_boar_accept": "Quanto dura questo evento?",
    "ideal_this_coyote_inspire": "Durata",
    "jumpy_tasty_rook_trust": "Durata",
    "real_big_crow_push": "Buffer prima di questo evento",
    "mealy_happy_ray_flop": "Buffer prima",
    "close_actual_deer_boil": "Buffer dopo",
    "keen_zippy_bulldog_gaze": "Buffer dopo questo evento",
    "seemly_fine_octopus_slurp": "Disponibilità",
    "each_awake_tadpole_jest": "Modifica tipo di evento",
    "extra_patient_warbler_praise": "Nessun evento da prenotare",
    "petty_swift_piranha_rise": "Programma evento",
    "broad_close_butterfly_drop": "Programma un appuntamento con {{name}}",
    "weary_known_gazelle_file": "Seleziona il tipo di appuntamento di cui hai bisogno e clicca sul pulsante di programmazione per prenotarlo. Otterrai un elenco di slot disponibili nel mio calendario.",
    "low_clean_haddock_bubble": "I miei tipi di eventi",
    "My Event Types": "I miei tipi di eventi",
    "pink_trite_ocelot_enrich": "Devi prima collegare il tuo calendario prima di poter aggiungere eventi!",
    "early_sweet_mantis_peek": "Aggiungi tipo di evento",
    "deft_suave_bear_pause": "Caricamento",
    "equal_jolly_thrush_empower": " minuti",
    "Schedule an appointment": "Programma un appuntamento",
    "heroic_kind_llama_zip": "Indietro",
    "awake_jolly_gazelle_lock": "Salta",
    "whole_acidic_parrot_promise": "Prenota appuntamento",
    "clear_close_racoon_pat": "{{value, dateTime}}",
    "cuddly_spare_felix_stir": "Passo {{val}}",
    "extra_misty_panda_grip": "Gli utenti possono utilizzare questo link per prenotare appuntamenti.",
    "sunny_great_halibut_empower": "Crea il primo",
    "create_first_event_type_button": "Tipo di evento",
    "application_title": "Appoint Me",
    "orange_grand_racoon_fall": "Come funziona {{app_title}}",
    "male_patient_hedgehog_ask": "{{app_title}} è un sistema di prenotazione appuntamenti semplice e facile da usare. Ti consente di creare eventi, condividere il tuo link e consentire agli utenti di prenotare appuntamenti con te.",
    "factual_moving_hawk_belong": "Specifica dove {{app_title}} aggiunge i tuoi appuntamenti e dove controlla se sei occupato.",
    "step_1_configure_calendars": "Passo 1: Configura calendari",
    "pink_polite_racoon_earn": "Passo 2: Crea eventi",
    "happy_wise_mantis_laugh": "\"Aggiungi i tuoi orari disponibili e sei pronto!\"",
    "careful_misty_bullock_splash": "Passo 3: Condividi il tuo link",
    "game_frail_vole_treasure": "Fatto! Congratulazioni!",
    "still_helpful_koala_trust": "Una volta che un utente prenota un appuntamento, l'evento viene aggiunto al tuo calendario.",
    "steep_fine_lobster_inspire": "Impossibile salvare il tipo di evento",
    "best_due_parakeet_zip": "Tipo di evento creato!",
    "happy_caring_fox_spur": "Evento salvato",
    "tasty_witty_stingray_hope": "Errore durante il salvataggio dell'evento",
    "trite_warm_gorilla_pet": "Aggiungi appuntamenti al calendario",
    "aware_alert_mare_glow": "Controlla il tempo libero nei calendari",
    "factual_nimble_snail_clap": "Salva modifiche",
    "tiny_teary_clownfish_vent": "Annulla",
    "lower_born_finch_dash": "Disconnetti da Google",
    "whole_formal_liger_rise": "Collega Google Calendar",
    "pink_loose_cougar_grin": "Il mio calendario",
    "upper_even_florian_peek": "Google Calendar",
    "merry_north_meerkat_cuddle": "Configurazione",
    "big_known_loris_revive": "Scegli i calendari per controllare gli orari occupati.",
    "large_suave_gull_hush": "copia link",
    "misty_proud_mallard_assure": "Copia link",
    "teal_lofty_hawk_peek": "Annulla",
    "mild_raw_elk_delight": "Salva modifiche",
    "Choose date": "Scegli data",
    "Please select a date": "Si prega di selezionare una data",
    "Choose time": "Scegli ora",
    "Provide details": "Fornisci dettagli",
    "Confirmation": "Conferma",
    "Please share anything that will help me to prepare for our meeting": "Condividi qualsiasi cosa che mi aiuterà a prepararmi per la nostra riunione",
    "confirmationText_male": "Hai prenotato un appuntamento {{event}} con {{name}} il {{date}} alle {{time}}.",
    "confirmationText_female": "Hai prenotato un appuntamento {{event}} con {{name}} il {{date}} alle {{time}}.",
    "confirmationText_neuter": "Hai prenotato un appuntamento {{event}} con {{name}} il {{date}} alle {{time}}.",
    "Name": "Nome",
    "Please provide your name": "Fornisci il tuo nome",
    "Email": "E-mail",
    "Information": "Informazione",
    "You will receive a confirmation email": "Riceverai un'e-mail di conferma",
    "Meeting with": "Riunione con",
    "Change": "Cambia",
    "Back": "Indietro",
    "Add Event Type": "Aggiungi tipo di evento",
    "Confirm & Book": "Conferma e prenota",
    "availableSlots": "I seguenti slot sono disponibili il {{date}}. Prenotane uno o scegli un altro giorno.",
    "minutes": "minuti",
    "Days": "Giorni",
    "Maximum days in advance": "Giorni massimi di anticipo",
    "event_advance_availability_description": "Quanti giorni in anticipo è disponibile questo tipo di evento?",
    "none": "Nessuno",
    "Select buffer": "Seleziona buffer",
    "Save": "Salva",
    "Select duration": "Seleziona durata",
    "Starttime": "Ora di inizio",
    "Endtime": "Ora di fine",
    "Add Account": "Aggiungi account",
    "Add CalDav Account": "Aggiungi account CalDav",
    "CalDav Accounts": "Account CalDav",
    "Server URL": "URL del server",
    "Username": "Nome utente",
    "label_password": "Password",
    "send_invitation_email": "Send invitation email",
    "send_invitation_email_notice": "Only needed if your CalDAV server does not send invitations automatically.",
    "invitationSubject": "Invito: {{summary}}",
    "invitationBody": "<p>Ciao {{attendeeName}},</p><p>Sei stato invitato al seguente evento:</p><h3>{{summary}}</h3><p>{{description}}</p><p><strong>Ora:</strong> {{time}}</p><p>Trovi i dettagli dell'evento in allegato.</p>",
    "icsDescription": "Descrizione dell'evento:\n{{description}}",
    "dateFormat": "it-IT",
    "user_menu_log_out": "Disconnettersi",
    "user_menu_log_in": "Accedi",
    "user_menu_profile": "Profilo",
    "user_menu_my_account": "Il mio account",
    "user_menu_calendar_integration": "Integrazione calendario",
    "user_menu_copy_link": "Copia il tuo link",
    "user_menu_link_copied": "Link copiato",
    "name": "Nome",
    "user_url": "URL utente",
    "use_gravatar": "Usa Gravatar",
    "save": "Salva",
    "profile_updated": "Profilo aggiornato con successo",
    "error_saving_profile": "Errore durante il salvataggio del profilo",
    "user_url_taken": "URL utente già in uso",
    "error_loading_profile": "Errore durante il caricamento del profilo",
    "login_with_sso": "Accedi con SSO",
    "login_with": "Accedi con",
    "login_successful": "Accesso riuscito",
    "login_failed": "Accesso fallito",
    "google_login_failed": "Accesso Google fallito",
    "Add": "Aggiungi",
    "Close": "Chiudi",
    "Choose calendars in which appointments are created.": "Scegli i calendari in cui vengono creati gli appuntamenti.",
    "Email (Optional)": "Email (Opzionale)",
    "Enter your CalDav server details to connect your calendar.": "Inserisci i dettagli del tuo server CalDav per collegare il tuo calendario.",
    "Failed to add account. Please check your credentials and server URL.": "Impossibile aggiungere l'account. Controlla le tue credenziali e l'URL del server.",
    "I acknowledge that my password will be stored encrypted in the database.": "Riconosco che la mia password verrà memorizzata crittografata nel database.",
    "event_copy_link": "Copia link",
    "link_copied_to_clipboard": "Link copiato negli appunti!",
    "link_copy_failed": "Impossibile copiare il link negli appunti!",
    "edit": "Modifica",
    "copy": "Copia",
    "Availability Mode": "Modalità di disponibilità",
    "Define Custom": "Definisci personalizzato",
    "Use Standard": "Usa standard",
    "Standard + Extra": "Standard + Extra",
    "Standard + Constraints": "Standard + Vincoli",
    "Standard Availability": "Disponibilità standard",
    "Using Standard Availability defined in Profile settings.": "Utilizzo della disponibilità standard definita nelle impostazioni del profilo.",
    "Define your standard weekly availability here. You can use this availability in your Event Types.": "Definisci qui la tua disponibilità settimanale standard. Puoi utilizzare questa disponibilità nei tuoi tipi di eventi.",
    "Copy Standard Availability": "Copia disponibilità standard",
    "Overwrite current availability with standard?": "Sovrascrivere la disponibilità attuale con quella standard?",
    "Profile": "Profilo",
    "about": "A proposito",
    "about_content": "# A proposito di AppointMe\n\nAppointMe è un semplice strumento per la pianificazione degli appuntamenti.\nConfigura i tuoi calendari, imposta la tua disponibilità e permetti agli altri di prenotare appuntamenti con te.\n\n## Github\n[Guarda il codice su Github](https://github.com/fhswf/appointme)\n\n## Crediti\nImplementato con ❤️ presso l'Università di Scienze Applicate della Westfalia Meridionale",
    "legal": "Note legali",
    "Calendar": "Calendario",
    "Select a calendar": "Seleziona un calendario",
    "No calendar selected": "Nessun calendario selezionato",
    "Calendar settings saved": "Impostazioni calendario salvate",
    "Failed to save settings": "Impossibile salvare le impostazioni",
    "Failed to load calendars for": "Impossibile caricare i calendari per",
    "Google Calendar disconnected": "Google Calendar disconnesso",
    "Failed to disconnect Google Calendar": "Impossibile disconnettere Google Calendar",
    "Connect a calendar to get started": "Collega un calendario per iniziare",
    "Online via Zoom": "Online via Zoom",
    "Language": "Lingua",
    "page not found": "Pagina non trovata",
    "GO HOME": "VAI ALLA HOME",
    "Impressum": "Note legali",
    "Datenschutzhinweise": "Informativa sulla privacy",
    "privacy_content": `
# Informativa sulla privacy

## Raccolta e utilizzo dei dati
Questa applicazione raccoglie e utilizza i dati personali per fornire servizi di pianificazione degli appuntamenti.

*   **Profilo utente:** Memorizziamo il tuo nome, indirizzo email e immagine del profilo per identificarti e personalizzare la tua esperienza.
*   **Dati utente Google:** Se connetti il tuo Google Calendar, accediamo ai dati del tuo calendario per:
    *   Controllare la tua disponibilità per evitare doppie prenotazioni.
    *   Creare nuovi eventi nel tuo calendario quando viene prenotato un appuntamento.
    *   **Non** utilizziamo i dati del tuo Google Calendar per altri scopi, come pubblicità o ricerche di mercato.
*   **Dati del calendario:** Memorizziamo le impostazioni di configurazione per i tuoi calendari connessi, i tipi di eventi che crei (nome, descrizione, luogo) e le prenotazioni degli appuntamenti.
*   **Dati di registro:** Il tuo indirizzo IP viene temporaneamente memorizzato nei file di registro del server per scopi di sicurezza e risoluzione dei problemi.
*   **Telemetria:** Raccogliamo dati di utilizzo anonimi e segnalazioni di errori utilizzando Sentry per migliorare la stabilità dell'applicazione.

## Condivisione dei dati
Non condividiamo i tuoi dati personali con terze parti, tranne quando necessario per fornire il servizio o come richiesto dalla legge.

*   **Dati utente Google:** I dati ottenuti dalle API di Google **non vengono condivisi** con strumenti di terze parti, modelli di intelligenza artificiale o entità esterne, tranne quando necessario per fornire le funzionalità di integrazione del calendario (ad esempio, comunicando con i server di Google).
*   **Fornitori di servizi:** Utilizziamo Sentry per il tracciamento degli errori e il monitoraggio delle applicazioni per garantire la stabilità del servizio. Questo fornitore può elaborare indirizzi IP e altri dati tecnici rigorosamente per la fornitura del servizio.
*   **Hosting:** L'applicazione è ospitata sulla nostra infrastruttura (cluster Kubernetes). Non utilizziamo CDN di terze parti o fornitori di hosting che ottengono quindi accesso ai tuoi dati.

## Archiviazione e protezione dei dati
I tuoi dati sono archiviati in modo sicuro sui nostri server.
*   **Crittografia:** Tutti i dati trasmessi tra il tuo browser e i nostri server sono crittografati tramite HTTPS. I dati sensibili come i token di accesso sono archiviati crittografati nel nostro database.
*   **Controllo degli accessi:** L'accesso ai tuoi dati è limitato al personale autorizzato e vi si accede solo quando necessario per supporto o manutenzione.

## Conservazione e cancellazione dei dati
*   **Conservazione:** Conserviamo il tuo profilo utente e i dati di configurazione del calendario finché il tuo account è attivo. I dati degli appuntamenti vengono conservati per fornirti una cronologia dei tuoi eventi programmati.
*   **Cancellazione:** Hai il diritto di richiedere la cancellazione dei tuoi dati. Puoi disconnettere il tuo Google Calendar in qualsiasi momento tramite le impostazioni dell'applicazione, il che rimuoverà il nostro accesso ai tuoi dati Google. Per richiedere la cancellazione completa dell'account e dei dati, contattaci all'indirizzo gawron.christian@fh-swf.de o utilizza la funzione di cancellazione dell'account nelle impostazioni del tuo profilo.

## Norme sui dati utente dei servizi API di Google
L'uso e il trasferimento da parte di AppointMe a qualsiasi altra app delle informazioni ricevute dalle API di Google rispetteranno le [Norme sui dati utente dei servizi API di Google](https://developers.google.com/terms/api-services-user-data-policy), compresi i requisiti di utilizzo limitato.`,
    "privacy_content_public": `
# Informativa sulla privacy

## Elaborazione dei dati

Al fine di prenotare un appuntamento, questa applicazione elabora i dati forniti (nome, indirizzo email, descrizione, data e ora dell'appuntamento). Questi dati vengono archiviati per gestire l'appuntamento e possono essere sincronizzati con il calendario dell'organizzatore.

## Telemetria

Utilizziamo Sentry per raccogliere dati di telemetria anonimi e segnalazioni di errori per migliorare la stabilità dell'applicazione.`,
    "impressum_content": "# Note legali\n\n## Disclaimer\nIl contenuto di questo server non fa parte dell'offerta online ufficiale dell'Università di Scienze Applicate della Vestfalia meridionale.",
    "CalDav Calendar": "Calendario CalDav",
    "loading": "Caricamento...",
    "Legal": "Note legali",
    "new_event_type": "Nuovo tipo di evento",
    "Appointment Summary": "Riepilogo appuntamento",
    "Could not book event": "Impossibile prenotare l'evento",
    "error_no_calendar": "Nessuna integrazione calendario configurata",
    "error_no_duration": "La durata deve essere maggiore di 0",
    "error_no_slots": "Nessuno slot orario configurato",
    "Active": "Attivo",
    "Inactive": "Inattivo",
    "delete": "Elimina",
    "Continue": "Continua",
    "Book Appointment": "Prenota appuntamento",
    "Available Times": "Orari disponibili",
    "No slots available": "Nessuno slot disponibile",
    "Schedule Appointment": "Programma appuntamento",
    "Available Meeting Types": "Tipi di riunione disponibili",
    "Please select a meeting type to view availability.": "Seleziona un tipo di riunione per visualizzare la disponibilità.",
    "All": "Tutti",
    "No public events found.": "Nessun evento pubblico trovato.",
    "Timezone": "Fuso orario",
    "Privacy & Terms": "Privacy e Termini",
    "Quick": "Veloce",
    "Consulting": "Consulenza",
    "Tags": "Etichette",
    "Type a tag and press Enter": "Scrivi un'etichetta e premi Invio",
    "Press Enter to add a tag": "Premi Invio per aggiungere un'etichetta",
    "Cancel": "Annulla",
    "landing_hero_title": "Appointment management <span class=\"text-primary\">made easy</span>",
    "landing_hero_subtitle": "Appoint Me is a simple and user-friendly solution for your appointments. Create events, share your link, and let others book appointments with you.",
    "landing_cta_start": "Start now",
    "landing_cta_learn_more": "Learn more",
    "landing_how_it_works_title": "How Appoint Me works",
    "landing_how_it_works_subtitle": "In just four simple steps to your organized calendar.",
    "landing_step1_title": "1. Configure calendar",
    "landing_step1_desc": "Determine where Appoint Me should enter appointments and where your availability should be checked. Connect your Google or Outlook calendar.",
    "landing_step2_title": "2. Create events",
    "landing_step2_desc": "Add your available times, define duration and break times, and get started!",
    "landing_step3_title": "3. Share your link",
    "landing_step3_desc": "Via your personal link, customers, colleagues, or friends can book appointments directly without annoying email ping-pong.",
    "landing_step4_title": "Done! Congrats!",
    "landing_step4_desc": "As soon as a user books an appointment, the event is automatically added to your calendar and both receive a confirmation.",
    "landing_footer_product": "Product",
    "landing_footer_features": "Features",
    "landing_footer_pricing": "Pricing",
    "landing_footer_integrations": "Integrations",
    "landing_footer_resources": "Resources",
    "landing_footer_documentation": "Documentation",
    "landing_footer_api": "API",
    "landing_footer_help_center": "Help Center",
    "landing_footer_legal": "Legal",
    "landing_footer_imprint": "Imprint",
    "landing_footer_privacy": "Privacy",
    "landing_footer_terms": "Terms & Conditions",
    "landing_footer_copyright": COPYRIGHT_ENGLISH,
    "landing_footer_tagline": "Simple appointment planning for everyone.",
    "Contact": "Contatto",
    "footer_credits": "Implementato con ❤️ presso l'Università di Scienze Applicate della Westfalia Meridionale",
    "terms_of_use_title": "Terms of Use",
    "terms_of_use_content": "# Terms of Use\n\n## Service Provision\n\nThis service is provided free of charge.\n\n## Disclaimer of Liability and Warranty\n\nNeither the authors nor the South Westphalia University of Applied Sciences accept any liability for damages of any kind or any warranty of any kind in connection with the use of this service. Use is at your own risk. This disclaimer does not apply to damages resulting from injury to life, body, or health based on an intentional or negligent breach of duty, nor to other damages based on an intentional or grossly negligent breach of duty.",
    "my_appointments": "I miei Appuntamenti",
    "no_upcoming_appointments": "Nessun appuntamento imminente trovato.",
    "appointment": "Appuntamento",
    "attendee": "Partecipante",
    "appointment_details": "Dettagli Appuntamento",
    "close": "Chiudi",
    "event_type": "Tipo di Evento",
    "week": "Settimana",
    "work_week": "Settimana Lavorativa",
    "day": "Giorno",
    "month": "Mese",
    "today": "Oggi",
    "agenda": "Agenda",
    "more": "altro",
    "next": "Successivo",
    "back": "Indietro",
    "n_more": "{{count}} altri ...",
    "Recurrence": "Ricorrenza",
    "Enable Recurring Event": "Abilita evento ricorrente",
    "Frequency": "Frequenza",
    "Weekly": "Settimanale",
    "Bi-weekly": "Bisettimanale",
    "Tri-weekly": "Ogni 3 settimane",
    "Monthly": "Mensile",
    "End Condition": "Condizione di fine",
    "Occurrences": "Occorrenze",
    "OR": "O",
    "Until Date": "Fino alla data",
    "Time Span": "Lasso di tempo",
    "Months": "Mesi",
    "Weeks": "Settimane",
    "Recurring Event": "Evento ricorrente",
    "Recurring": "Ricorrente",
    "weekly": "Settimanale",
    "biweekly": "Bisettimanale",
    "triweekly": "Ogni 3 settimane",
    "monthly": "Mensile",
    "Series Booking Note: Students will book all occurrences at once.": "Nota prenotazione in serie: Gli studenti prenoteranno tutte le occorrenze in una volta sola.",
    "Feedback": "Feedback",
    "Student Only": "Solo studenti",
    "Restricted to Students": "Limitato agli studenti",
    "Settings exported successfully": "Impostazioni esportate con successo",
    "Failed to export settings": "Impossibile esportare le impostazioni",
    "Are you sure you want to import settings? This will overwrite your current profile and events.": "Sei sicuro di voler importare le impostazioni? Questo sovrascriverà il tuo profilo attuale e gli eventi.",
    "Settings imported successfully": "Impostazioni importate con successo",
    "Failed to import settings": "Impossibile importare le impostazioni",
    "Invalid file format": "Formato file non valido",
    "Data": "Dati",
    "Export Settings": "Esporta impostazioni",
    "Download your settings and events as a JSON file.": "Scarica le tue impostazioni e gli eventi come file JSON.",
    "Export Data": "Esporta dati",
    "Import Settings": "Importa impostazioni",
    "Restore your settings from a JSON file. This will overwrite existing data.": "Ripristina le tue impostazioni da un file JSON. Questo sovrascriverà i dati esistenti.",
    "Select File": "Seleziona file",
    "Online Meeting": "Riunione online",
    "You are logged in via your Learning Management System. Please use the specific booking links provided in your course to book appointments.": "Hai effettuato l'accesso tramite il tuo Learning Management System. Utilizza i link di prenotazione specifici forniti nel tuo corso per prenotare gli appuntamenti.",
    "Logout": "Disconnettersi",
    "MyProvider": "Il mio provider",
    "Grammatical Gender": "Genere grammaticale",
    "Male": "Maschile",
    "Female": "Femminile",
    "Neuter": "Neutro",
    "gender_help_text": "Utilizzato per la grammatica corretta nei messaggi di conferma.",
    "Changelog": "Changelog",
    "Failed to load changelog data.": "Impossibile caricare i dati del registro delle modifiche.",
    "See what's new and what has been fixed.": "Scopri le novità e le correzioni apportate.",
    "Reminder setting": "Impostazione promemoria",
    "Notification type": "Tipo di notifica",
    "System notification": "Notifica di sistema",
    "No reminder": "Nessun promemoria",
    "Reminder time": "Ora del promemoria",
    "Reminder settings saved": "Impostazioni promemoria salvate",
    "At event start": "All'inizio dell'evento",
    "minutes before": "minuti prima",
    "1 day before": "1 giorno prima",
    "days before": "giorni prima",
    "1 hour before": "1 ora prima",
    "hours before": "ore prima"
};
//# sourceMappingURL=it.js.map